module.exports = __webpack_public_path__ + "img/1473957020.bbd387e9.jpg";